import { useState, useEffect, lazy, Suspense } from 'react';
import { useCookies } from 'react-cookie';
import moment from 'moment';
import Layout from 'components/common/NewLayout';
import Meta from 'components/common/Meta';

// Lazy load components
const Top = lazy(() => import('components/home/Top'));
const Main = lazy(() => import('components/home/Main'));
const Info = lazy(() => import('components/home/Info'));
const Target = lazy(() => import('components/home/Target'));
const Method1 = lazy(() => import('components/home/Method1'));
const Method2 = lazy(() => import('components/home/Method2'));
const Method3 = lazy(() => import('components/home/Method3'));
const Tip = lazy(() => import('components/home/Tip'));
const Shop = lazy(() => import('components/home/Shop'));
const Bottom = lazy(() => import('components/home/Bottom'));
const NoticePopup = lazy(() => import('components/home/NoticePopup'));
const HomePopup = lazy(() => import('components/home/HomePopup'));

// Loading component
const Loading = () => (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    Loading...
  </div>
);

const Home = () => {
  const [cookie, setCookie] = useCookies(['hideMallpiePopup']);
  const [popup, setPopup] = useState<boolean>(false);
  const targetDate = moment('2024-08-13 17:00', 'YYYY-MM-DD HH:mm');

  useEffect(() => {
    const hidePopup = cookie.hideMallpiePopup;
    if (!hidePopup) {
      setPopup(true);
    }
  }, []);

  const handleDontShowAgain = () => {
    const nowDate = new Date();
    nowDate.setDate(nowDate.getDate() + 7);

    setCookie('hideMallpiePopup', true, {
      path: '/',
      expires: nowDate,
    });
    setPopup(false);
  };

  const handleClosePopup = () => {
    setPopup(false);
  };

  const goToLink = () => {
    window.open('https://event-us.kr/m/88500/19632', '_blank');
  };

  return (
    <Layout theme="black">
      <Meta
        title="몰파이 | 쇼핑몰의 쉬운 시작"
        ogTitle="몰파이 | 쇼핑몰의 쉬운 시작"
      />
      <Suspense fallback={<Loading />}>
        <Top />
        <Main />
        <Info />
        <Target />
        <Method1 />
        <Method2 />
        <Method3 />
        <Tip />
        <Shop />
        <Bottom />
      </Suspense>

      {/* <NoticePopup
        open={popup}
        onClose={handleClosePopup}
        onDontShowAgain={handleDontShowAgain}
      /> */}
      {/* <HomePopup
        open={popup}
        onClose={handleClosePopup}
        onDontShowAgain={handleDontShowAgain}
        goToLink={goToLink}
      /> */}
    </Layout>
  );
};

export default Home;
